<nz-modal #modalRef nzSize [(nzVisible)]="isVisible"
  [nzTitle]="editorTitle | translate"
  (nzOnCancel)="handleCancel()" nzCancelText="Cancel" nzOkText="Save" nzOkType="primary" [nzFooter]="null"
  class="custom-modal-class">
  <ng-container *nzModalContent>
    <form [formGroup]="careTeamForm" (ngSubmit)="submitForm()"
      [ngClass]="{'plan-submitted': careTeamSubmitted, 'plan-not-submitted': !careTeamSubmitted}">

      <div class="form-row" fxLayout="row" fxLayoutAlign="start start">
        <div fxLayout="col" fxLayoutAlign="start center" fxFlex="30">
          <label>{{"Template" | translate}}</label>
        </div>
        <div fxLayout="col" fxLayoutAlign="start start" fxFlex="70">
          <nz-select formControlName="careTeamTemplateId" nzShowSearch nzAllowClear
            [nzPlaceHolder]="'Select Template' | translate" class="inputs plan">
            @for (template of templateOptions; track template.id) {
              <nz-option [nzValue]="template.id"
                [nzLabel]="template.name + ' (' + template.careTeamCategoryDisplay + ')'"></nz-option>
            }
          </nz-select>
        </div>
      </div>

      @if (!isEdit || isTemplateEditable || isReadOnly) {
        <div class="form-row" fxLayout="row" fxLayoutAlign="start start">
          <div fxLayout="col" fxLayoutAlign="start center" fxFlex="30">
            <label>{{"Onset Date" | translate}}</label>
          </div>
          <div fxLayout="column" fxLayoutAlign="start start" fxFlex="70">
            <input nz-input class="inputs plan" type="date" [placeholder]="'Onset Date' | translate"
              formControlName="onSetDateTime" />
            @if (careTeamForm.get('onSetDateTime')?.errors?.['maxDate'] && careTeamForm.get('onSetDateTime')?.touched) {
              <span class="red" style="font-size:12px">{{ "Onset date must be before end date" | translate }}</span>
            }
          </div>
        </div>
      }

      <div class="form-row" fxLayout="row" fxLayoutAlign="start start">
        <div fxLayout="col" fxLayoutAlign="start center" fxFlex="30">
          <label>{{"End Date" | translate}}</label>
        </div>
        <div fxLayout="col" fxLayoutAlign="start start" fxFlex="70">
          <input nz-input class="inputs plan" type="date" [placeholder]="'End Date' | translate"
            formControlName="endDateTime" [min]="!isEdit ? careTeamForm.get('onSetDateTime')?.value || getCurrentDate() : null" />
        </div>
      </div>

      <div fxLayout="row" fxLayoutAlign="end" class="footer">
        @if (!isReadOnly) {
          <button nz-button nzPrimary class="save-btn" type="submit" [nzLoading]="isLoading"
            [disabled]="isSaveDisabled">{{"Save" | translate}}</button>
        }
        <button nz-button nzDanger class="cancel-btn" type="button" (click)="handleCancel()"
          [disabled]="isLoading">{{ (isReadOnly ? "Close" : "Cancel") | translate }}</button>
      </div>
    </form>
  </ng-container>
  <ng-template>
    <button type="submit">{{"Save" | translate}}</button>
  </ng-template>
</nz-modal>
